import React from 'react';
import { ThresholdType } from '../../models/commonEnums';
import styles from './ThresholdDot.module.scss';

type Props = {
    type: ThresholdType;
};

const ThresholdDot = ({ type }: Props): React.ReactElement => {
    const isRed = [ThresholdType.LOW_ALERT, ThresholdType.HIGH_ALERT].includes(type);
    const className = isRed ? styles.dotColorRed : styles.dotColorYellow;

    return <span className={className} />;
};

export default ThresholdDot;
